import React, { useEffect, useMemo, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Col, Row } from 'react-bootstrap';
import { ActionButton, Toggle } from '@fluentui/react';
import { downloadFile, isNullUndefinedOrEmpty, showMessage } from '../../../common/Helpers';

import { useGetContractParties, useGetPartieFormConfig, useGetPresentation } from '../../../hooks/component/sPay/useOfContractParties';

import TableHeads from './Table/ContractPartie/TableHeads';
import TableItems from './Table/ContractPartie/TableItems';

import Loading from '../../../components/Templates/Site/Loading';
import PayContractInfo from '../../../components/Products/sPay/PayContractInfo';

import SidePanelViewContractPartie from './SidePanels/SidePanelViewContractPartie';
import SidePanelInsertEditContractPartie from './SidePanels/SidePanelInsertEditContractPartie';
import SidePanelInsertEditContractSubPartie from './SidePanels/SidePanelInsertEditContractSubPartie';
import SidePanelViewContractSubPartie from './SidePanels/SidePanelViewContractSubPartie';

import 'jqwidgets-scripts/jqwidgets/styles/jqx.base.css';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.material.css';
import { action_updateContractPartieList, action_updateContractPartieSidePanelIsOpen } from '../../../reducers/actions/PAY/actions';
import { __MessageTypes, enum_CONTACTPARTIE_PARTIE_FORM_VIEW, enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW, enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG } from '../../../common/Dictionaries';
import SidePanelFinalizeParties from './SidePanels/SidePanelFinalizeParties';
import { getContractPartieElementLog } from '../../../services/sPay/partie.service';
import { __onGoToBoardEP } from '../../../common/SystemRedirections';
import { getValidateModificacionPartidas } from '../../../services/sPay/edpConfig.service';
import MessageBoxInfoComplex from '../../../components/Common/Message/MessageBoxInfoComplex';
import { action_setBoardViewElementId } from '../../../reducers/actions/KPI/actions';
import { useGetContractModificationMaintainer } from '../../../hooks/services/sKPI/useOfContractModification';

const ContractParties = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const {
        _firsLoad: firsLoad,
        _contractPresentation: contractPresentation,
        _contractParties: contractParties,
        _contractPartieSidePanelsConfig: contractPartieSidePanelsConfig,
        _contractPartieSelected: contractPartieSelected,
        _contractSubPartieSelected: contractSubPartieSelected,

        _contractFormPartieConfig: contractFormPartieConfig,
    } = useSelector((state) => state.contractPartiesState);
    
    const { _elementId: elementId } = useSelector((state) => state.boardViewScope);

    const queryStringElementId = !isNullUndefinedOrEmpty(props.match.params.elementId) ? props.match.params.elementId : null;

    const tableHeads_Resources = [
        { id: '1', name: '',                             class: 'w-2',  prop: 'collapseExpand' },
        { id: '2', name: 'N°',                           class: 'w-4',  prop: 'id'             },
        { id: '3', name: t('data-lang-lbl-code'),        class: 'w-4',  prop: 'code'           },
        { id: '4', name: t('data-lang-lbl-class'),       class: 'w-18', prop: 'class'          },
        { id: '5', name: t('data-lang-lbl-type'),        class: 'w-10', prop: 'type'           },
        { id: '6', name: t('data-lang-lbl-name'),        class: 'w-5',  prop: 'name'           },
        { id: '7', name: t('data-lang-lbl-gastoprevio-short'), class: 'w-5',  prop: 'prevExpense'    },
        { id: '8', name: t('data-lang-lbl-totalmonth'),  class: 'w-5',  prop: 'totalAmount'    },
        { id: '9', name: t('data-lang-lbl-internalcode'),class: 'w-9',  prop: 'internalcode'   },
        { id: '10', name: t('data-lang-lbl-actions'),    class: 'w-6',  prop: ''               }
    ];

    const tableHeads_ContractParties = [
        { id: '1',  name: '',                               class: 'w-2',  prop: 'collapseExpand'        },
        { id: '2',  name: 'N°',                             class: 'w-2',  prop: 'id'                    },
        { id: '3',  name: t('data-lang-lbl-code'),          class: 'w-4',  prop: 'code'                  },
        { id: '4',  name: t('data-lang-lbl-class'),         class: 'w-15', prop: 'class'                 },
        { id: '5',  name: t('data-lang-lbl-type'),          class: 'w-9', prop: 'type'                  },
        { id: '6',  name: t('data-lang-lbl-name'),          class: 'w-15', prop: 'name'                  },
        { id: '7',  name: t('data-lang-lbl-modcontract'),   class: 'w-6',  prop: 'contractMondification' },
        { id: '8',  name: t('data-lang-lbl-startmonth'),    class: 'w-5',  prop: 'startMonth'            },
        { id: '9',  name: t('data-lang-lbl-endmonth'),      class: 'w-6',  prop: 'endMonth'              },
        { id: '10', name: t('data-lang-lbl-previousmonth'), class: 'w-5',  prop: 'prevMonth'             },
        { id: '11', name: t('data-lang-lbl-currency'),      class: 'w-4',  prop: 'currency'              },
        { id: '12', name: t('data-lang-lbl-gastoprevio-short'),   class: 'w-5',  prop: 'prevExpense'           },
        { id: '13', name: t('data-lang-lbl-totalmonth'),    class: 'w-6',  prop: 'totalAmount'           },
        { id: '14', name: t('data-lang-lbl-internalcode'),  class: 'w-7',  prop: 'internalcode'          },
        { id: '15', name: t('data-lang-lbl-actions'),       class: 'w-9',  prop: ''                      }
    ];

    const [showModifyPartiesAlert, setShowModifyPartiesAlert] = useState(false);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [objIsValidForm, setObjIsValidForm] = useState({
        visible_btnCargar           : null,
        visible_btnCerrarPartidas   : null,
        visible_btnModificaPartida  : null,
        visible_hlNuevaPartida      : null,
        visible_btnLog              : null,
    });

    const [collapseAll, setCollapseAll] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [fireGetPresentation, setFireGetPresentation] = useState(false);
    const [fireGetContractParties, setFireGetContractParties] = useState(false);
    const [fireGetPartieFormConfig, setFireGetPartieFormConfig] = useState(false);

    useGetPresentation(contractPresentation, queryStringElementId, fireGetPresentation, setFireGetPresentation)
    useGetContractParties(contractParties, queryStringElementId, fireGetContractParties, setFireGetContractParties)
    useGetPartieFormConfig(queryStringElementId, contractFormPartieConfig, fireGetPartieFormConfig, setFireGetPartieFormConfig)

    const [listContractModification, setListContractModification] = useState(null);
    useGetContractModificationMaintainer(listContractModification, setListContractModification)

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(parseInt(event.target.value));
        setCurrentPage(1);
    };

    const handleOpenInsertPartiePanel = () => {
        dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_INSERT, true))
    }

    const handleOnGoToBulkPartie = () => {
        window.location.href = `/Kpi/BulkUpload/${queryStringElementId}`
    }

    const handleOpenFinalizePartiesPanel = () => {
        dispatch(action_updateContractPartieSidePanelIsOpen(enum_CONTRACT_PARTIE_SIDEPANELS_CONFIG.IS_OPEN_PARTIE_FINISH, true));
        setFireGetPresentation(true);
        setFireGetContractParties(true);
        setFireGetPartieFormConfig(true);
    }

    const handleOpenModifyPartiesDialog = async () => {
        await getValidateModificacionPartidas(parseInt(queryStringElementId)).then((response) => {
            if (response.data.succeeded) {
                if (response.data.data.result) {
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                    setFireGetPresentation(true)
                    setFireGetContractParties(true)
                    setFireGetPartieFormConfig(true)
                }
                else {
                    if (response.data.data.l_messages.length > 0) {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, response.data.data.l_messages);
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    }
                }
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-downloadpartieslogserror'))
            }
        }).catch((ex) => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    }

    const handleDownloadPartiesLog = async () => {
        if ((objIsValidForm.visible_btnLog || true) && contractPresentation !== null && contractPresentation.item_contrato !== null) {
            await getContractPartieElementLog(parseInt(queryStringElementId)).then((response) => {
                if (!isNullUndefinedOrEmpty(response.data)) {
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                    downloadFile(response.data, `${contractPresentation.item_contrato.contractCode}-PartidasLog.xlsx`);//Agergar el código de contrato al nombre del archivo.
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-downloadpartieslogserror'))
                }
            }).catch((ex) => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-cantdownloadpartiesbyrule'))
        }
    };

    const handleSwitchCollapseAll = (checked) => {
        contractParties.forEach(partie => {
            partie.collapse = !checked;
            partie.l_SUBPARTIDA.forEach(subpartie => {
                subpartie.collapse = !checked;
            });
        });
        setCollapseAll(!checked)
        dispatch(action_updateContractPartieList(contractParties))
    }

    const findMaxValue = (list, property) => {
        // Verifica si la lista es nula o está vacía
        if (!list || list.length === 0) {
            return null;
        }
      
        // Utiliza reduce para encontrar el valor máximo
        const maxValue = list.reduce((max, item) => {
            const num = parseFloat(item[property]); // Convierte la propiedad a número
            return !isNaN(num) && num > max ? num : max; // Compara y decide el nuevo máximo
        }, null); // Valor inicial de null para el máximo
      
        return maxValue;
    };

    const Vista = () => {
        const is_admin = true;
        const is_aad = true;

        const estado_partida_abierta = contractPresentation.estado_partida_abierta;
        const estado_contrato = contractPresentation.estado_contrato_modificable;
        let enableBtnUsuario = false;
        let enable_btn = false;

        if (is_admin | is_aad)
        {
            enable_btn = true;
            enableBtnUsuario = !estado_contrato ? false : enable_btn;
        }

        objIsValidForm.visible_btnCargar = !estado_contrato ? false : estado_partida_abierta ? is_admin : false;
        objIsValidForm.visible_btnCerrarPartidas = !estado_contrato ? false : estado_partida_abierta ? enable_btn : false;
        let mod_vigente = false;

        if (!estado_partida_abierta)
        {
            mod_vigente = findMaxValue(contractFormPartieConfig.l_NRO_MC, ) > 0 ? true : false;
        }
        objIsValidForm.visible_btnModificaPartida = !estado_contrato ? false : estado_partida_abierta ? false : (enable_btn ? (!contractFormPartieConfig.tiene_ep ? true : (mod_vigente ? true : false)) : false);
        objIsValidForm.visible_hlNuevaPartida = !estado_contrato ? false : estado_partida_abierta ? enable_btn : false;
        objIsValidForm.visible_btnLog = !enable_btn ? false : estado_partida_abierta ? false : true;
    
        setObjIsValidForm(objIsValidForm);
        setCollapseAll(false)
    }

    // Aquí se usa useMemo para calcular filteredData cuando cambien tickets o searchTerm
    const filteredData = useMemo(() => {
        if (!contractParties) return [];
            return contractParties ? contractParties.filter(item =>
            item.iteM_PARTIDA.nombrePartida.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.iteM_PARTIDA.clasePartidaTitle.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.iteM_PARTIDA.tipoPartidaTitle.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.iteM_PARTIDA.codigoPartida.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.iteM_PARTIDA.mesInicioPartida.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.iteM_PARTIDA.mesTerminoPartida.toString().toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.iteM_PARTIDA.monedaPartida.toString().toLowerCase().includes(searchTerm.toLowerCase())
        ) : [];
    }, [contractParties, searchTerm]);

    // Calcular la paginación basada en los datos filtrados
    const indexOfFirstItemFiltered = (currentPage - 1) * itemsPerPage;
    const indexOfLastItemFiltered = Math.min(indexOfFirstItemFiltered + itemsPerPage, filteredData.length);
    const currentFilteredData = filteredData.slice(indexOfFirstItemFiltered, indexOfLastItemFiltered);

    //Funciona como un page load.
    useEffect(() => {
        if (objIsValidForm.visible_btnModificaPartida === null && contractFormPartieConfig !== null && contractPresentation !== null) {
            Vista();
        }
    }, [objIsValidForm, contractFormPartieConfig, contractPresentation]);

    useEffect(() => {
        if (isNullUndefinedOrEmpty(elementId)) {
            dispatch(action_setBoardViewElementId(queryStringElementId));
        }
    }, [elementId]);

    return (
        <div>
            {
                !firsLoad &&
                <Loading inputParam_ShowLoading={true}/>
            }
            {
                firsLoad && contractFormPartieConfig && contractPresentation && listContractModification &&
                <>
                    <Row>
                        <Card >
                            <Card.Body>
                                <Row>
                                    <Col>
                                        <PayContractInfo />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Row>
                                            <Col>
                                            </Col>
                                            <Col className='col-auto ms-auto my-auto'>
                                                <input type="text" placeholder={t('data-lang-btn-search') + "..."} value={searchTerm} onChange={handleSearch} />
                                            </Col>
                                            <Col className='col-auto ms-auto'>
                                                <div className='d-flex'>
                                                    <ActionButton iconProps={{ iconName: 'PaymentCard' }} styles={{root: {height: "30px"}}} onClick={ () => __onGoToBoardEP(queryStringElementId) }>{ t('data-lang-lbl-baktoedp') }</ActionButton>
                                                    {
                                                        contractPresentation.visible_btn_nueva_partida && //(objIsValidForm.visible_hlNuevaPartida === true) &&
                                                        <ActionButton iconProps={{ iconName: 'AddToShoppingList' }} styles={{root: {height: "30px"}}} onClick={ handleOpenInsertPartiePanel }>{ t('data-lang-btn-createparties') }</ActionButton>
                                                    }
                                                    {
                                                        contractPresentation.visible_btn_modificar_partida && //contractPresentation && !contractPresentation.tiene_ep && !contractPresentation.estado_partida_abierta &&
                                                        <ActionButton iconProps={{ iconName: 'Edit' }} styles={{root: {height: "30px"}}} onClick={ handleOpenModifyPartiesDialog }>{ t('data-lang-btn-modifyparties') }</ActionButton>
                                                    }
                                                    {
                                                        contractPresentation.visible_btn_cerrar_partida && //(objIsValidForm.visible_btnCerrarPartidas === true && currentFilteredData && currentFilteredData.length > 0) &&
                                                        <ActionButton iconProps={{ iconName: 'Lock' }} styles={{root: {height: "30px"}}} onClick={ handleOpenFinalizePartiesPanel }>{ t('data-lang-btn-finalizeparties') }</ActionButton>
                                                    }
                                                    {
                                                        contractPresentation.visible_btn_cargar_partida && //(objIsValidForm.visible_btnCargar === true) &&
                                                        <ActionButton iconProps={{ iconName: 'BulkUpload' }} styles={{root: {height: "30px"}}} onClick={ handleOnGoToBulkPartie }>{ t('data-lang-btn-uploadparties') }</ActionButton>
                                                    }
                                                    {
                                                        (contractPresentation.visible_btn_log || true) && //(objIsValidForm.visible_btnLog === true) && //02-09-2025 Se solicita quitar regla de visibilidad.
                                                        <ActionButton iconProps={{ iconName: 'Download' }} styles={{root: {height: "30px"}}} onClick={ handleDownloadPartiesLog }>{ t('data-lang-btn-downloadpartieslogs') }</ActionButton>
                                                    }
                                                </div>
                                            </Col>
                                            <Col className='col-auto ms-auto'>
                                                <Toggle
                                                    inlineLabel
                                                    checked={ collapseAll !== null ? collapseAll : false }
                                                    onChange={ () => handleSwitchCollapseAll(collapseAll) }
                                                    role="checkbox"
                                                    onText={t('data-lang-lbl-expandall')}
                                                    offText={t("data-lang-lbl-collapseall")}
                                                    styles={ {root:{ paddingTop: "10px", float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                                />
                                            </Col>
                                        </Row>
                                        <Card.Footer>    
                                            {
                                                messageConfig.showMessage &&
                                                <MessageBoxInfoComplex
                                                    inputParam_Width="100%"
                                                    inputParam_TranslateText={true}
                                                    inputParam_Display={messageConfig.showMessage}
                                                    inputParam_ShowClose={true}
                                                    inputParam_Message={ messageConfig.message }
                                                    inputParam_MessageType={messageConfig.messageType}
                                                    inputParam_CustomSetterMessage={true}
                                                    inputParam_SetterMessage={setMessageConfig}
                                                />
                                            }
                                            {
                                                contractPresentation.visible_tramitacion_alert &&
                                                <MessageBoxInfoComplex
                                                    inputParam_Width="100%"
                                                    inputParam_TranslateText={true}
                                                    inputParam_Display={contractPresentation.visible_tramitacion_alert}
                                                    inputParam_ShowClose={false}
                                                    inputParam_Message={ t('data-lang-msg-contractpartie-edp-inprogress') }
                                                    inputParam_MessageType={__MessageTypes.WARNING}
                                                />
                                            }
                                        </Card.Footer>
                                        <table className="table mt-3 table-striped table-bordered table-sm">
                                            <TableHeads tableHeads={tableHeads_ContractParties} />
                                            <TableItems list_mc={listContractModification} tableItems={currentFilteredData} tableHeads={tableHeads_Resources} editEnabled={contractPresentation.visible_btn_cargar_partida}/>
                                        </table>
                                        <div className='row'>
                                            <div className='col'>
                                            <div className='w-25'>
                                                <select className="form-select form-select-sm" value={itemsPerPage} onChange={handleItemsPerPageChange}>
                                                    <option value={5}>5 {t('data-lang-lbl-perpage')}</option>
                                                    <option value={10}>10 {t('data-lang-lbl-perpage')}</option>
                                                    <option value={20}>20 {t('data-lang-lbl-perpage')}</option>
                                                </select>
                                            </div>
                                            </div>
                                            <div className='col float-end'>
                                            <ul className="pagination">                      
                                                <li className="page-item" disabled={currentPage === 1}>
                                                    <a className={"page-link " + (currentPage === 1 ? 'disabled' : '') }  href="#" onClick={() => setCurrentPage(currentPage - 1)} disabled>Previous</a>
                                                </li>
                                                <li className="page-item">
                                                    <a className={"page-link " + (indexOfLastItemFiltered >= filteredData.length ? 'disabled' : '') } href="#" onClick={() => setCurrentPage(currentPage + 1)}>Next</a>
                                                </li>
                                            </ul>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Row>
                    {
                        contractPartieSelected && contractPartieSidePanelsConfig.isPanelViewPartieOpen &&
                        <SidePanelViewContractPartie />
                    }
                    {
                        contractPartieSelected && contractPartieSidePanelsConfig.isPanelEditPartieOpen &&
                        <SidePanelInsertEditContractPartie elementId={parseInt(queryStringElementId)} formView={enum_CONTACTPARTIE_PARTIE_FORM_VIEW.EDIT} />
                    }
                    {
                        contractPartieSidePanelsConfig.isPanelInsertPartieOpen &&
                        <SidePanelInsertEditContractPartie elementId={parseInt(queryStringElementId)} formView={enum_CONTACTPARTIE_PARTIE_FORM_VIEW.INSERT} />
                    }
                    

                    {
                        contractSubPartieSelected && contractPartieSidePanelsConfig.isPanelViewSubPartieOpen &&
                        <SidePanelViewContractSubPartie />
                    }
                    {
                        contractPartieSelected && contractSubPartieSelected && contractPartieSidePanelsConfig.isPanelEditSubPartieOpen &&
                        <SidePanelInsertEditContractSubPartie elementId={parseInt(queryStringElementId)} formView={enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.EDIT} />
                    }
                    {
                        contractPartieSelected && contractPartieSidePanelsConfig.isPanelInsertSubPartieOpen &&
                        <SidePanelInsertEditContractSubPartie elementId={parseInt(queryStringElementId)} formView={enum_CONTACTPARTIE_SUBPARTIE_FORM_VIEW.INSERT} />
                    }

                    {
                        contractPartieSidePanelsConfig.isPanelFinishPartieOpen &&
                        <SidePanelFinalizeParties elementId={parseInt(queryStringElementId)} contractCode={contractPresentation.item_contrato.contractCode} />
                    }
                </>
            }
        </div>
  );
};

export default ContractParties;
